import { IconButton, Typography, rating } from "@material-tailwind/react";
import React from "react";
import { HeartIcon, ShareIcon, PlayIcon } from "@heroicons/react/24/outline";
import { EyeIcon } from "@heroicons/react/24/solid";

import {
  FilmIcon,
  MusicalNoteIcon,
  BookOpenIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import SharePopover from "./SharePopover";
import { getYear, returnSubCategoryName, toFixed } from "../helper/helper";
import { useReduxStore } from "../hooks/useReduxStore";
import { updateHome } from "../store/Reducers/homeReducer";
import FavouriteBtn from "./FavouriteBtn";
import { DetailPageUrl } from "../services/API";
import { getItemAccessType, isUserSubscribed } from "../helper/accessTypeHelper";

export default function DetailBanner({
  rating = "4.0",
  views = 1,
  type = "movie",
  description,
  image = "https://img.freepik.com/free-photo/movie-background-collage_23-2149876028.jpg?w=900&t=st=1701434772~exp=1701435372~hmac=0ea91e43e3ad843fa0a52d9f8d2935642eb09535679f293198c7ce530a45f30f",
  title,
  cast,
  author,
  sub_category,
  released_date,
  publish_date,
  onClickBuy,
  isPurchased = false,
  onWishClick,
  price,
  exclusive_content,
  ppv_content,
  is_favourite,
  width,
  id,
  onFeaturedClick,
  feature_video,
  dark = false,
  onWatch: propOnWatch,
}) {
  const { getState } = useReduxStore();

  const { userData } = getState("AUTH");
  sub_category = returnSubCategoryName(sub_category);
  const isMusic = type === "Audio";
  const isMovie = type === "Video";
  const isEbook = type === "ebook";
  const isAudioBook = type === "audio_book";

  const access = getItemAccessType({
    price,
    exclusive_content,
    ppv_content,
  });

  const isSubscribed = isUserSubscribed(userData);

  const isEffectivelyAccessible =
    isPurchased || access.isFree || (access.isExclusive && isSubscribed);

  const typeName = `${
    isAudioBook
      ? "Audio Book"
      : isEbook
      ? "Book"
      : isMusic
      ? "Music"
      : isMovie
      ? "Movie"
      : "Season"
  }`;
  const navigate = useNavigate();
  // const onAddToCart = () => {
  //   navigate("/AddToCart");
  // };
  const onWatch = () => {
    if (propOnWatch) {
      propOnWatch();
    } else {
      navigate("/Vedio");
    }
  };


  const onFirstBtnPress = () => {
    if (isEffectivelyAccessible) {
      onWatch();
    } else if (access.isExclusive) {
      navigate("/Subscription");
    } else {
      onClickBuy();
    }
  };
  return (
    <div
      style={{
        backgroundImage: `url(${image})`,
      }}
      id="Detail"
      className={`relative w-full min-h-[65vh] md:h-[80vh] py-16 md:py-24 flex items-center justify-start bg-cover bg-center bg-no-repeat overflow-hidden shadow-2xl`}
    >
      {/* Immersive gradient background covering mobile as well */}
      <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r from-black via-black/90 md:via-black/75 to-black/10 z-0"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-14 flex flex-col md:flex-row gap-10 items-center justify-between">
        <div className="w-full md:w-3/5 text-center md:text-left flex flex-col justify-center">
          <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
            <span className="text-secondary text-xs sm:text-sm font-bold uppercase tracking-widest block">
              {typeName}
            </span>
            <span
              className={`px-2.5 py-0.5 rounded-full text-[10px] font-extrabold uppercase tracking-wide ${access.badgeClass}`}
            >
              {access.badgeText}
            </span>
          </div>
          <h2 className={`text-3xl sm:text-4xl lg:text-6xl font-bold tracking-tight leading-tight md:leading-[1.15] mb-4 text-white`}>
            {title || "INCEPTIONS"}
          </h2>
          
          <div className="flex items-center justify-center md:justify-start gap-4 mb-4 text-xs sm:text-sm font-medium">
            <span className="flex items-center gap-1.5 text-secondary">
              <FilmIcon className="h-5 w-5" />
              {sub_category}
            </span>
            <span className="h-1 w-1 rounded-full bg-zinc-700"></span>
            <span className="flex items-center gap-1.5 text-zinc-300">
              <EyeIcon className="h-4 w-4" />
              {views} views
            </span>
          </div>

          {!isMusic && (
            <p className="text-zinc-300 text-sm sm:text-base lg:text-lg leading-relaxed mb-6 line-clamp-3">
              {description ||
                "An intelligence operative for a shadowy global peacekeeping agency races to stop a hacker from stealing its most valuable — and dangerous — weapon."}
            </p>
          )}

          <Typography
            className="text-zinc-300 text-xs sm:text-sm font-semibold mb-2"
          >
            By : <span className="text-secondary font-bold">{cast || author || "Christopher Nolan"}</span>
          </Typography>

          {!isPurchased && (
            <div className="mb-6 flex items-center justify-center md:justify-start gap-2">
              <Typography className="text-white text-sm sm:text-base font-semibold">
                {access.isFree
                  ? "Access : "
                  : access.isExclusive
                  ? "Membership : "
                  : access.isPpv
                  ? "Rental Price : "
                  : "Price : "}
              </Typography>
              {access.isFree ? (
                <span className="text-emerald-400 text-lg font-black bg-emerald-500/10 px-2.5 py-0.5 rounded border border-emerald-500/30">
                  FREE
                </span>
              ) : access.isExclusive ? (
                isSubscribed ? (
                  <span className="text-secondary text-sm font-bold bg-secondary/15 px-3 py-1 rounded-full border border-secondary/30 flex items-center gap-1.5">
                    <span>👑</span> Included with VIP Membership
                  </span>
                ) : (
                  <span className="text-amber-400 text-base font-black bg-amber-500/10 px-2.5 py-0.5 rounded border border-amber-500/30">
                    Subscribers Only
                  </span>
                )
              ) : access.isPpv ? (
                <span className="text-purple-300 text-lg font-black bg-purple-500/15 px-2.5 py-0.5 rounded border border-purple-500/30">
                  $ {toFixed(price)} (PPV)
                </span>
              ) : (
                <span className="text-secondary text-lg font-bold">
                  $ {toFixed(price)}
                </span>
              )}
            </div>
          )}

          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start items-center mt-4">
            <button
              onClick={onFirstBtnPress}
              className="w-full sm:w-auto px-8 py-3 rounded-lg font-bold text-sm bg-secondary hover:bg-secondary/90 text-white shadow-lg shadow-secondary/20 transition-all duration-300 hover:scale-[1.02] active:scale-98 flex items-center justify-center gap-2"
            >
              {!isEffectivelyAccessible
                ? access.isExclusive
                  ? "Subscribe to "
                  : access.isPpv
                  ? "Rent PPV & "
                  : "Buy and "
                : ""}
              {isMusic
                ? "Play Now"
                : isEbook
                ? "Read E-Book"
                : isAudioBook
                ? "Listen Now"
                : "Watch Now"}
            </button>

            {feature_video && (
              <button
                onClick={onFeaturedClick}
                className="w-full sm:w-auto px-6 py-3 rounded-lg font-bold text-sm border border-zinc-700 hover:border-secondary bg-white/5 hover:bg-white/10 text-white transition-all duration-300 hover:scale-[1.02] active:scale-98 flex items-center justify-center gap-2"
              >
                Watch Promo
              </button>
            )}

            <div className="flex items-center gap-4 mt-2 sm:mt-0">
              <FavouriteBtn
                is_favourite={is_favourite}
                onClick={onWishClick}
                isLight={true}
                dark={dark}
              />

              <SharePopover
                link={`${DetailPageUrl}?id=${id}`}
                isDark={false}
                dark={dark}
              />
            </div>
          </div>
        </div>
        
        {/* Transparent spacer to push content left */}
        <div className="hidden lg:block w-1/4"></div>
      </div>
    </div>
  );
}

